import Validator from 'validatorjs';
import {createError} from 'apollo-errors';
import handleInput from "./helpers/handleInput";

const ValidationError = createError('ValidationError', {
    message: 'Validation error'
})

export default function validate(types, rules, customErrorMessages = {}) {
    types = Array.isArray(types) ? types : [types];

    const handler = async (argType, argValue, argName, path) => {
        const validator = new Validator({...argValue}, rules, customErrorMessages);
        await new Promise((resolve, reject) => {
            validator.checkAsync(resolve, () => {
                throw new ValidationError({data: validator.errors.all()})
            })
        })
    }
    return ({typeDefs, resolvers}) => {
        for (let type of types) {
            typeDefs = handleInput(typeDefs, type, handler)
        }
        return {typeDefs, resolvers};
    }
}
